// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { userHelmetSafety16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-user-helmet-safety': IconUserHelmetSafety;
    }
}

/**
 * The icon component for the 'userHelmetSafety' icon
 */
export class IconUserHelmetSafety extends IconSvg {
    public constructor() {
        super(userHelmetSafety16X16);
    }
}

registerIconSvg('icon-user-helmet-safety', IconUserHelmetSafety);
export const iconUserHelmetSafetyTag = 'nimble-icon-user-helmet-safety';
